import { render } from "./EtatAddEdit.vue?vue&type=template&id=502542dc"
import script from "./EtatAddEdit.vue?vue&type=script&lang=ts"
export * from "./EtatAddEdit.vue?vue&type=script&lang=ts"
script.render = render

export default script